import RapidBatchSearchApi from 'api/RapidBatchSearchApi';
import { getPropertyDistanceFromLocation } from 'lib/PropertyUtils';
import { resolveDistance } from 'lib/distanceResolver';

export async function getComparableSales(targetPropertyId, propertyId, latitude, longitude) {
  return getComparableItem('sales', targetPropertyId, propertyId, latitude, longitude);
}

export async function getComparableListings(targetPropertyId, propertyId, latitude, longitude) {
  return getComparableItem('listings', targetPropertyId, propertyId, latitude, longitude);
}

export async function getComparableRentals(targetPropertyId, propertyId, latitude, longitude) {
  return getComparableItem('rentals', targetPropertyId, propertyId, latitude, longitude);
}

async function getComparableItem(comparableType, targetPropertyId, propertyId, latitude, longitude) {
  const targetCoords = { lat: latitude, lon: longitude };

  const rapidResponse = await RapidBatchSearchApi.getRapidBatchSearch(
      {
        propertyIds: [propertyId],
      },
      comparableType || 'sales',
      targetCoords
  );

  const comparableData = rapidResponse?.data?.[0];
  const comparableCoords = comparableData
      ? { lat: comparableData.latitude, lon: comparableData.longitude }
      : null;

  const calculatedDistance = comparableCoords
      ? getPropertyDistanceFromLocation(targetCoords, comparableCoords)
      : null;
  const distance = resolveDistance(comparableData?.distance, calculatedDistance);

  return rapidResponse?.metadata?.totalElements
      ? {
        ...comparableData,
        distance,
      }
      : {};
}
